import {  Component, inject, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { Route, Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MpsUserService } from '../../services/mps-user.service';
import { isNil } from 'lodash';
import { Subject } from 'rxjs';
import { Role } from '../../../app/modules/_models/role';
import { User } from '../../../app/modules/_models/user';
@Component({
  selector: 'mps-app-navigation',
  templateUrl: './mps-navigation.component.html',
  styleUrls: ['./mps-navigation.component.scss'],
  imports: [TranslatePipe, MatMenuModule, RouterModule],

  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MpsNavigationComponent {
   //private _user: User;
  private _routes: Route[] = [];
  private _mobileRoutes: Route[] = [];
  expanded = {
    workspace: false,
    administration: false,
    indexes: false
  };
  isMobile = new Subject<boolean>();
  _user?: User;

  private readonly _userService = inject(MpsUserService);
  private readonly _router = inject(Router);
  private readonly _elementRef = inject(ElementRef);
  private readonly _sidenav = inject(MatSidenav, { optional: true, host: true });

  ngOnInit(): void {
    this._user = new User(this._userService.getUser()!);
  }
  
  canViewAdminMenu(): boolean {
    let res = false;
    if (!isNil(this._user)) {
      this._user?.roles.forEach((r: Role) => {
        const adminPermissions = r.permissions.administration;
        res ||= (adminPermissions?.currencies?.edit && adminPermissions?.workspaces?.edit && adminPermissions?.users?.edit &&
          adminPermissions?.loading_sites?.edit && adminPermissions?.indexes?.edit && adminPermissions?.packagings?.edit && adminPermissions?.sales_organisations?.edit
        );
      });
    }

    return res;
  }

  isMenuActive(menu: string): boolean {
    let currentPath =  this._router.url;
    let pathElements = currentPath.split('/');
    pathElements.splice(pathElements.length - 1, 1)
    return currentPath != "" && pathElements.includes(menu);
  }

  expand(label: string): void {
    this.expanded[label as keyof typeof this.expanded] = !this.expanded[label as keyof typeof this.expanded];
    Object.keys(this.expanded).forEach(key => {
      if (this.expanded[label as keyof typeof this.expanded] && label != key) {
        this.expanded[key as keyof typeof this.expanded] = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.detectScreenSize();
  }

  private detectScreenSize() {
    this.isMobile.next(window.innerWidth < 992);
  }

  public getRoutes(mobile = false): Route[] {
    return mobile ? this._mobileRoutes : this._routes;
  }

  public close(): void {
    if (this._sidenav) {
      this._sidenav.close();
    }
  }
}
